export function listObjToArray(data) {
  console.log(Object.prototype.toString.call(data))
  let dataArr = []
  if (Object.prototype.toString.call(data) === '[object Object]' && Object.keys(data).length > 0) {
    for (const key in data) {
      dataArr.push(data[key])
    }
  }
  if (Object.prototype.toString.call(data) === '[object Array]' && data.length > 0) {
    dataArr = data;
  }

  return dataArr;
}
